function isInvalidVideoSlug(slug: string): boolean {
  // Encoded check (%...)
  if (/%[0-9A-Fa-f]{2}/.test(slug)) {
    return true
  }
  // Non-ASCII character check
  return /[^\x00-\x7F]/.test(slug);
}

export default defineNuxtRouteMiddleware(async (to) => {
  const rc = useRuntimeConfig();
  const localePath = useLocalePath()
  let videoSlug = to.params.slug as string
  if (isInvalidVideoSlug(videoSlug)) {
    videoSlug = 'placeholder'
  }
  const video = useState<Video|null>('currentVideo', () => null)
  let redirectUrl: string | null = null
  let errorStatus: number = 500

  const videoId = to.params.id ? Number(to.params.id) : 0;
  const videoRes = await useFetch<VideoApiResponse>(`/v2/videos/${videoId}/${videoSlug}`, {
    baseURL: rc.public.wadApiBaseUrl,
    redirect: 'manual',
    onResponse({ response }) {
      if (response.status === 301 && response._data) {
        redirectUrl = localePath({
          name: 'videos-id-slug',
          params: {
            id: response._data.video_id ?? 0,
            slug: response._data.video_slug ?? null,
          },
        });
      }
    },
    onResponseError({ response }) {
      errorStatus = response.status as number;
    },
  });

  const { data: videoData, error: videoError } = videoRes;

  if(videoError.value) {
    throw showError({ statusCode: errorStatus ?? 500, fatal: true });
  }

  if(redirectUrl) {
    return navigateTo(redirectUrl, { redirectCode: 301 })
  }

  video.value = videoData.value?.data ?? null
})
